import { paramUrl } from '../constants/parameterNames';
import { success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';

const description = "Allows users to delete a document in SharePoint.";

const requiredParameters = {
    [paramUrl]: {
        description: 'Item URL'
    },
};

const ERROR_BLANK_URL = "URL cannot be blank.";

const executeAsync = async ({ parameters, sharePointAccess }) => {
    const url = getParamValue(parameters, paramUrl);

    if (!url) {
        throw new Error(ERROR_BLANK_URL);
    }

    await sharePointAccess.deleteFileAsync(url);

    return success();
};

const DeleteFromSharePoint = {
    description,
    executeAsync,
    requiredParameters,
};

export default DeleteFromSharePoint;